<template>
	<section class="transactions section section--mini">
		<Deposit :deposit="item" v-for="item in items" :key="item.id" />
	</section>
</template>
<script lang="ts" setup>
import "./DepositsView.scss";
import {computed, onMounted, ref, watch} from "vue";
import moment from "moment";
import Icon from "@/components/Icon/Icon.vue";
import {useApiStore} from "@/stores/apiStore";
import DepositEntity from "@/entities/DepositEntity";
import Deposit from "@/components/Deposit/Deposit.vue";

interface Props{
	orderBy : 'asc' | 'desc'
}

let {api} = useApiStore();

let props = withDefaults(defineProps<Props>(), {
	orderBy: 'desc'
});

let items = ref<DepositEntity[]>([]);
let loading = ref<boolean>(false);

async function loadDeposits(){

	loading.value = true;

	let deposits = await api.getDeposits(1, 100, {
		mode : props.orderBy,
		field : 'id'
	});

	items.value = deposits.items;
	loading.value = false;

}

onMounted(loadDeposits);
watch(() => props.orderBy, loadDeposits);

</script>